// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wtv-stats[data-v-639203f8]{flex-flow:row wrap;justify-content:space-between;flex:2 0 100%!important}.wtv-stats-item[data-v-639203f8]{padding:8px}", ""]);
// Exports
module.exports = exports;
